import { SectionHead, Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const ModelsLine = () => {
  const { t } = useLang();
  return (
    <section id="models" className="relative bg-canvas bp-grid py-24 sm:py-32" data-testid="models-section">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
        <SectionHead eyebrow={t.models.eyebrow} title={t.models.title} desc={t.models.desc} testid="models" />
        <Reveal delay={0.2}>
          <div
            data-testid="models-note"
            className="mt-8 flex max-w-3xl items-center gap-3 border border-dashed border-[rgba(122,22,32,0.4)] bg-white px-5 py-4"
          >
            <span className="pulse-dot inline-block h-2 w-2 shrink-0 rounded-full bg-red-brand" />
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.12em] text-[#525964]">{t.models.note}</p>
          </div>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {t.models.items.map((m, i) => (
            <Reveal key={m.code} delay={(i % 4) * 0.08}>
              <article
                data-testid={`model-card-${i}`}
                className="group relative h-full border border-technical bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(22,24,27,0.35)] hover:border-[rgba(122,22,32,0.4)]"
              >
                <div className="relative flex h-52 items-center justify-center overflow-hidden bg-canvas bp-grid p-5">
                  <img
                    src={m.img}
                    alt={`MargTor ${m.code}`}
                    className="max-h-full max-w-full object-contain drop-shadow-[0_14px_18px_rgba(22,24,27,0.22)] transition-transform duration-500 group-hover:scale-[1.06]"
                  />
                  <span className="chamfer-sm absolute top-3 left-3 bg-red-brand px-2.5 py-1 font-mono-tech text-[9px] font-semibold uppercase tracking-[0.18em] text-[#f8f7f4]">
                    {m.cat}
                  </span>
                </div>
                <div className="border-t border-technical p-5">
                  <h3 className="font-display text-lg font-extrabold tracking-tight text-ink">{m.code}</h3>
                  <ul className="mt-2.5 space-y-1.5">
                    {m.specs.map((s) => (
                      <li key={s} className="flex items-center gap-2 font-mono-tech text-[10px] tracking-wide text-[#525964]">
                        <span className="inline-block h-1 w-1 rotate-45 bg-red-brand" />
                        {s}
                      </li>
                    ))}
                  </ul>
                  {m.platform && (
                    <dl className="mt-4 border-t border-dashed border-technical pt-3 space-y-1.5" data-testid={`model-provenance-${i}`}>
                      <div className="flex gap-2 font-mono-tech text-[9.5px] uppercase tracking-[0.12em]">
                        <dt className="shrink-0 text-red-brand">{t.models.platformLabel}</dt>
                        <dd className="text-ink">{m.platform}</dd>
                      </div>
                      <div className="flex gap-2 font-mono-tech text-[9.5px] uppercase tracking-[0.12em]">
                        <dt className="shrink-0 text-red-brand">{t.models.scopeLabel}</dt>
                        <dd className="text-[#525964]">{m.scope}</dd>
                      </div>
                    </dl>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
